import {
  Component,
  Injector,
  Optional
} from '@angular/core';
import {CommonModule} from "@angular/common";

import {DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler} from "@wm/components-base";
import {FormsModule} from "@angular/forms";

const DEFAULT_CLS = 'app-input-wrapper';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-textarea',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: 'wm-textarea',
  template: `<textarea class="form-control app-textarea"
                       focus-target
                       role="textbox"
                       [attr.name]="name"
                       [(ngModel)]="datavalue"
                       [ngModelOptions]="ngModelOptions"
                       [readonly]="readonly"
                       [required]="required"
                       [disabled]="disabled"
                       [maxlength]="maxchars"
                       [attr.tabindex]="tabindex"
                       [attr.placeholder]="placeholder"
                       [attr.accesskey]="shortcutkey"
                       [attr.aria-label]="hint || 'Textarea field'"
                       aria-multiline="true"
                       [autofocus]="autofocus"
                       #textarea></textarea>`,
  providers: [
    provideAsWidgetRef(TextareaComponent)
  ],
  exportAs: 'wmTextarea',
  standalone: true,
  imports: [CommonModule, FormsModule],
  styles: []
})
export class TextareaComponent extends StylableComponent {
  static initializeProps = register('wm-textarea');

  public required: boolean;
  public maxchars: number;
  public disabled: boolean;
  public name: string;
  public readonly: boolean;
  public tabindex: any;
  public placeholder: any;
  public shortcutkey: string;
  public autofocus: boolean;
  public hint: string;
  public limitdisplaytext: string;
  public charlength: number = 0;
  ngModelOptions: any;
  datavalue: any;

  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);


  }

  override get stylerEl(): HTMLElement {
    return this.nativeElement.querySelector('textarea.app-textarea') || this.nativeElement;
  }

  protected override onPropertyChange(this: any, key: string, nv: string, ov?: any) {
    var wdgtProperties = this.widgetProps;
    if (key === 'maxchars') {
      wdgtProperties.limitdisplaytext.show = !!nv;
    } else {
      super.onPropertyChange(key, nv, ov);
    }

  }

}
